import { ZealApiResponse, VeriffIDVDecisionResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TGetVeriffDecisionRequestSchema } from "./getVeriffDecision.schema";

export const getVeriffDecision = (axios: IAxiosInstance) => {
  return async (data: TGetVeriffDecisionRequestSchema) => {
    const response = await axios.noRetry.get<
      ZealApiResponse<VeriffIDVDecisionResponse>
    >(`/api/getVeriffDecision`, {
      params: data,
    });

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
